module.exports = __webpack_public_path__ + "img/a3639cc.jpg";